export default "__VITE_ASSET__3be30c66__"